import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchUser, updateUser } from "actions/user";

import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/User/Form";

class UserEdit extends Component {
  componentDidMount() {
    const { match, fetchUser } = this.props;
    const id = match.params.userId;
    fetchUser(id);
  }

  shapedDefaultValuesStructure() {
    const { ...rest } = this.props.user.data;

    return Object.assign(
      {},
      {
        ...rest
      }
    );
  }

  updateUser(id, data) {
    const { toggleNotification, toggleFullPageSpinner, updateUser, history } = this.props;

    toggleFullPageSpinner(true);

    updateUser(id, data)
      .then(() => {
        toggleNotification(true, { message: "Updated User Success", infoClassName: "is-success" });
        history.push(`/users`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const id = this.props.match.params.userId;

    this.updateUser(id, data);
  };

  render() {
    const { user } = this.props;

    if (user.loading) {
      return "loading";
    }
    const defaultValues = this.shapedDefaultValuesStructure();
    return <Form handleFormSubmit={this.handleFormSubmit} defaultValues={defaultValues} />;
  }
}

const mapStateToProps = ({ user }) => ({
  user
});

export default connect(
  mapStateToProps,
  {
    fetchUser,
    updateUser,
    toggleFullPageSpinner,
    toggleNotification
  }
)(UserEdit);



// WEBPACK FOOTER //
// ./src/pages/User/Edit/index.js